"use strict";
/**
* Copyright: Microsoft 2016
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var internal_1 = require("../types/internal");
var logger_1 = require("../common/logger");
var placeholder_1 = require("./placeholder");
var React = require("react");
var translationKey_1 = require("./translationKey");
var keyCounter = 0;
//helper for construction of jsx constructor
var createDomElementProperties = function (element, navigationAction) {
    var properties = __assign({}, element);
    delete properties['type'];
    // anchor
    if (element.type === 'a') {
        if (navigationAction) {
            delete properties['href'];
            properties.onClick = function () { navigationAction(element.href); };
        }
        else {
            // @TODO : THIS SEEMS TO BE SRM SPECIFIC - PERHAPS IT SHOULD MOVE OUTSIDE OF THIS LIB
            properties.target = '_blank';
        }
        // force displaying hand cursor when click handler is used
        if (properties.onClick && !properties.href) {
            properties.href = 'javascript:void(0)';
        }
    }
    return properties;
};
//conversion to jsx constructor
var getElement = function (element, resolveChildren, navigationAction) {
    return {
        key: element.key,
        construct: function () {
            var props = createDomElementProperties(element.value, navigationAction);
            props.children = resolveChildren();
            props.key = (keyCounter++) + element.key;
            return React.createElement(element.value.type, props);
        }
    };
};
//handling dictionary specifics
var findInDictionary = function (dict, key) {
    var filtered = dict.filter(function (item) {
        return item.key === key;
    });
    return filtered && filtered[0] && filtered[0].construct;
};
//conversion to jsx constructor
var getComponent = function (collection, key) {
    var element = findInDictionary(collection, key.toPascalCase());
    if (element) {
        return element;
    }
    logger_1.logger.warning('No component provided for ' + (key.isPlaceholder ? 'placeholder' : 'tag') + ' ' + key.value);
    return function (builder) {
        return {
            type: 'span',
            key: (keyCounter++) + key.value,
            props: {
                children: key.isTag ?
                    builder(key.content) :
                    placeholder_1.placeHolder.toPlaceholder(key.value)
            }
        };
    };
};
//conversion to jsx constructor
var getDomElements = function (params, navigationAction, builder) {
    return params.domElements.map(function (elem) {
        return getElement(elem, function () {
            return builder(elem.body);
        }, navigationAction);
    });
};
var cloneWithKey = function (elem, key) {
    var props = __assign({}, elem.props);
    props.key = key;
    return React.createElement(elem.type.toString(), props);
};
//conversion to jsx constructor
var getJsxElements = function (dict) {
    return dict.map(function (elem) {
        return {
            key: elem.key,
            construct: function () {
                if (typeof elem.value.type === 'string') {
                    return cloneWithKey(elem.value, (keyCounter++) + elem.key);
                }
                else {
                    return elem.value;
                }
            }
        };
    });
};
//relative key handling for auto-localization
var getLocalizedString = function (key, params) {
    var actualKey = translationKey_1.translationKey.getActualKey(key, params.text);
    var translated = internal_1.internalStringLoader.getString(actualKey);
    if (translated !== actualKey) {
        return translated;
    }
    logger_1.logger.warning('Fallback to placeholder because key ' + actualKey + ' is not translatable');
    return placeholder_1.placeHolder.toPlaceholder(actualKey);
};
//conversion to jsx constructor
var getLocalizableElements = function (elements, params, navigationAction) {
    return elements.map(function (elem) {
        return getElement(elem, function () {
            return getLocalizedString(elem.value.translationKey || elem.key, params);
        }, navigationAction);
    });
};
//conversion to jsx constructor *
var addElementConstructor = function (collection, elements) {
    elements.forEach(function (element) {
        collection.push(element);
    });
    return collection;
};
//conversion to jsx constructor *
exports.getElements = function (params, navigationAction, builder) {
    var elements = [];
    elements = addElementConstructor(elements, getDomElements(params, navigationAction, builder));
    elements = addElementConstructor(elements, getJsxElements(params.jsxElements));
    elements = addElementConstructor(elements, getLocalizableElements(params.localizableElements, params, navigationAction));
    return elements;
};
//rendering of jsx elements
exports.buildComponent = function (elements, part, builder) {
    if (part.isTag || part.isPlaceholder) {
        return getComponent(elements, part)(builder);
    }
    return React.createElement("span", { key: ((keyCounter++) + part.value) }, part.value);
};
//rendering of jsx elements
exports.buildComponents = function (knownPlaceholders, params, navigationAction) {
    var builder = function (parts) {
        return exports.buildComponents(parts, params, navigationAction);
    };
    var elements = exports.getElements(params, navigationAction, builder);
    if (knownPlaceholders.length === 0) {
        return null; // tslint:disable-line:no-null-keyword
    }
    if (knownPlaceholders.length === 1) {
        return exports.buildComponent(elements, knownPlaceholders[0], builder);
    }
    return knownPlaceholders.map(function (part) {
        return exports.buildComponent(elements, part, builder);
    });
};
